import { GetImages } from "../../../../../utils/GetImages";
import { TextCss } from "../../../../GlobalCss/TextCss";
import "./DataAttribute.css";
import React, { useState } from "react";

const DataAttributePanel = ({ groupedAttributes }) => {
  const [openGroup, setOpenGroup] = useState<string>("Basics");

  return (
    <div className="data-attribute-container">
      {groupedAttributes.map((group, i) => (
        <div key={i} className="data-group">
          
          <div className="data-group-header" onClick={() => setOpenGroup(openGroup === group.groupName ? "" : group.groupName)}>
            <div className="group-left">
              <img src={group.icon} className={"color-white-icon" + (group.className ? " " + group.className : " group-icon")} />
              <p className={TextCss.black.heading_600_16}>{group.groupName}</p>
            </div>

            <img
              src={GetImages.BlackChevronDown}
              className={`group-chevron iconstyle24 color-white-icon ${openGroup === group.groupName ? "rotate" : ""}`}
            />
          </div>

          {openGroup === group.groupName && (
            <div className="data-group-items">
              {group.items.map((attr, j) => (
                <div
                  key={j}
                  className="attribute-item"
                  draggable
                  onDragStart={(e) => {
                    e.dataTransfer.clearData();
                    e.dataTransfer.setData("text", attr.placeholder);
                    e.dataTransfer.setData("application/json", JSON.stringify(attr));
                  }}
                >
                  <img src={GetImages.GripDots} className="drag-icon color-white-icon" />
                  <p className={TextCss.black.sub_text_400_12}>{attr.name}</p>
                </div>
              ))}
            </div>
          )}

        </div>
      ))}
    </div>
  );
};

export default DataAttributePanel;

